import React from 'react';
import ReactLoading from 'react-loading';

import { Container } from './styles';

const Loading: React.FC = () => {
  return (
    <Container>
      <ReactLoading type="cylon" color="#f99000" height={667} width={375} />
    </Container>
  );
};

export default Loading;
